export default __webpack_public_path__ + "static/N0119-56817c1965e8950d756bb31c176b8d1f.png";